exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wv-card{box-sizing:border-box;padding:20px;border-radius:4px;background:#fff}.wv-card__with-shadow{box-shadow:0px 0px 2px rgba(0,0,0,.12),0px 2px 2px rgba(0,0,0,.05)}", ""]);

// exports
